import { Injectable } from '@angular/core';
import { MatSnackBarConfig } from '@angular/material/snack-bar';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable()
export class Messaging {
    constructor(private snackBar: MatSnackBar) { }

    showMessage(messageText: string) {
        const config = new MatSnackBarConfig();
        config.duration = 5000;
        config.verticalPosition = 'bottom';
        config.horizontalPosition = 'right';
        this.snackBar.open(messageText, "Dismiss", config);
    }

    showUndoableMessage(messageText: string) {
        const config = new MatSnackBarConfig();
        config.duration = 5000;
        config.verticalPosition = 'bottom';
        config.horizontalPosition = 'center';
        return this.snackBar.open(messageText, 'Undo', config);
    }
}
